import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {IBetLineWinData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import {NoWinSymbolsWinPresentationController} from "@nolimitcity/slot-game/bin/game/winpresentation/nowinsymbols/NoWinSymbolsWinPresentationController";
import {TweenLite} from "gsap";

export class CCTwoNoWinSymbolsWinPresentationController extends NoWinSymbolsWinPresentationController {

    protected getBetLineSymbolWinStates():void {
        const numOfRows = 3,
            symId = 0;

        (<IBetLineWinData[]>this._betWinsData!).forEach((betLineWinData:IBetLineWinData) => {
            for(let reelId:number = 0; reelId < betLineWinData.nrOfSymbols; reelId++) {
                const symbolId:number = betLineWinData.betLine[reelId];
                this._symbolWinStates[(reelId * numOfRows) + symbolId][symId] = true; // overridden here to work as per 15 reels.
                this.updateStackedSymbolWinStates(reelId, symbolId);
            }
        });
    }

    protected stopWinPresentation(isAborted:boolean):void {
        // If abort before running this wp, we don't need to reset no win symbols.
        if(isAborted) {
            return;
        }

        let noWinSymbol:StateReelSymbol | null;
        for(let i:number = 0; i < this._symbolWinStates.length; i++) {
            for(let j:number = 0; j < this._symbolWinStates[i].length; j++) {
                if(this._symbolWinStates[i][j]) {
                    continue;
                }

                noWinSymbol = Reels.getSymbol(i, j);
                if(noWinSymbol == null) {
                    continue;
                }

                TweenLite.to(noWinSymbol, 0.5, {alpha : 0.35});
                this._noWinSymbols.push(noWinSymbol);
            }
        }
    }
}